export default {"src":"/_next/static/media/inner-2.a84789f3.svg","height":74,"width":74,"blurWidth":0,"blurHeight":0};